import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import TUBE from '@common/images/tube_placed.svg';
import ROTOR from '@common/images/rotor_placed.svg';
import ROTOR_AND_TUBE from '@common/images/tube_rotor_placed.svg';
import { Image } from '@learningblocks/shared-components/lib/Image';

/**
 * Slot:
 *  renders each slot contents(if any) in microcentrifuge
 */
export function Slot(props) {
  const {t} = useTranslation();
  const [imageSrc, setSrc] = React.useState(null);
  React.useEffect(() => {
    if (props.rotor && props.solution) setSrc(ROTOR_AND_TUBE);
    else if (props.rotor) setSrc(ROTOR);
    else if (props.solution) setSrc(TUBE);
    else setSrc(null);
  }, [props]);

  const onDragStart = (event) => {
    event.dataTransfer.setData('id', props.id);
  };

  const onDragOver = (event) => {
    event.preventDefault();
  };

  const onDrop = (event) => {
    event.preventDefault();
    const droppedId = parseInt(event.dataTransfer.getData('id'));
    props.onDrop({droppedId: droppedId, locationId: props.id});
  };

  const hasSolution = props.solution

  const moveTubeWithSpaceOrEnter = (event) => {
    if (event.code == 'Enter' || event.code == 'Space') {
      if (props.tubePickedUp) {
        props.onDrop({ droppedId: props.id, locationId: props.pickedUpTubeId });
        props.setTubePickedUp(false)
      } else {
        props.setPickedUpTubeId(props.id)
        props.setTubePickedUp(true)
      }
    }
  }

  return (
    <div
      className={props.className}
      draggable={true}
      onDragStart={onDragStart}
      onDrop={onDrop}
      onDragOver={onDragOver}
      aria-label={hasSolution ? '' : t('SlotEmpty.string', {slot: props.id})}
      tabIndex="0"
      onKeyPress={moveTubeWithSpaceOrEnter}
    >
      {imageSrc === null ? null : (
        <Image style={{ width: '100%', height: '100%' }} src={imageSrc} aria-live="polite" alt={t('TubeInSlot.string', {slot: props.id})} />
    )}  
    </div>
  );
}

Slot.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * specifies if rotor is present at slot
   */
  rotor: PropTypes.bool,
  /**
   * specifies if solution is present at slot
   */
  solution: PropTypes.bool,
  /**
   * id of slot
   */
  id: PropTypes.number,
};

Slot.defaultProps = {
  className: '',
};
